/**
 * 全角英数字を半角英数字に変換する
 * @param str 全角英数字を含む文字列
 */
export function zenkaku2Hankaku(str: string) {
  return str.replace(/[Ａ-Ｚａ-ｚ０-９]/g, s => {
    return String.fromCharCode(s.charCodeAt(0) - 0xfee0);
  });
}

/**
 * マッチする文字列を強調したhtmlテキストを取得する
 */
// export function getKeywordEmphasizedTextNode(
//   text: string,
//   keywords: string[]
// ): React.ReactNode {
//   let repText = text;

//   // 全キーワードの前後に開始・終了タグを埋め込む
//   const beginTag = "\t"; // 開始タグ＝水平タブ
//   const endTag = "\v"; // 終了タグ＝垂直タブ
//   keywords.forEach((keyword: string) => {
//     const pattern = new RegExp(`(${keyword})`, "g");
//     // const matches = repText.matchAll(pattern);
//     repText = repText.replace(pattern, `${beginTag}$1${endTag}`);
//   });

//   // 開始・終了タグの位置で切り出してコンポーネント化する
//   // TODO
//   return repText;
// }

/**
 * Elastic Search Simple Query 文字列からキーワードを抽出する
 */
export function getKeywordsFromESSimpleQuery(query: string) {
  // console.log(`★query: ${query}`);
  // console.log(query);

  // 前後空白を取り除く
  let replacedStr = query.replace(/^\s+|\s+$/g, "");
  // 連続する半角スペースを１つにまとめる
  replacedStr = replacedStr.replace(/ +/g, " ");

  // ダブルクォートに括られた部分を切り出す
  const quoteRegExp = new RegExp(/"(.+?)"/g);
  const quoteMatches = query.matchAll(quoteRegExp);
  replacedStr = query.replace(quoteRegExp, "");
  const quoteKeywords = Array.from(quoteMatches).map((match: any) => {
    return match["1"];
  });

  // 連続する半角スペースを１つにまとめる
  replacedStr = replacedStr.replace(/ +/g, " ");

  // +,|,-,*,(,),~N,半角・全角スペース で分割する
  // eslint-disable-next-line no-irregular-whitespace
  const dividerPattern = new RegExp(/(\*|\+|-|\||\(|\)| +|　+|~N)/g);
  const splited = replacedStr.split(dividerPattern);
  const filteredKeywords = splited.filter((keyword: string) => {
    if (!keyword) {
      return false;
    }
    if (keyword.match(/^\s+$/)) {
      return false;
    }
    return true;
  });

  // 結果を結合する
  const result = quoteKeywords.concat(filteredKeywords);
  return result;
}
